import { IconGroupItem } from 'Icons';
import styles from 'partials/timeline.module.scss';

export const TimelineGroupItem = ({title}) => {
	return (
		<div className={styles.group}>
			<IconGroupItem className={styles.groupIcon} />
			<span className={styles.groupCount}>{title}</span>
		</div>
	);
};
